import { ReactElement } from "react";
import { Text, AgGrid } from "@jsq/ds/core";
import EntityStatusCellDropDownRenderer from "./EntityStatusCellDropDownRenderer";

export const createRenderEntityStatusCell = (updateLoading: boolean) => {
  const RenderEntityStatusCell = (params: AgGrid.ICellRendererParams): ReactElement => {
    const entityData = params.data;
    const isDropdownEnabled = !(updateLoading || Boolean(entityData?.showSpinner));

    if (isDropdownEnabled) {
      return <EntityStatusCellDropDownRenderer params={params} />;
    } else {
      return <Text>{params.value}</Text>;
    }
  };

  return RenderEntityStatusCell;
};
